import { Button, Tooltip } from 'antd';
import { EyeFilled, SnippetsFilled, FileTextFilled, FolderOpenFilled } from '@ant-design/icons';
import dayjs from 'dayjs'

const Columns = ({ showModal, isSuperuser, hasAnyRole, canGapsRead, canGapsUpdate, handleOpenChangeLog }) => {
  return [
    /* {
      title: 'Issue',
      dataIndex: 'code',
      key: 'code',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      render: (code) => `Issue ${code}`,
    }, */
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
    },
    {
      title: 'Estado',
      dataIndex: 'status',
      key: 'status',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      render: (status) => status?.name || 'No especificada'
    },
    {
      title: 'Fecha Comprometida',
      dataIndex: 'date_committed',
      key: 'date_committed',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' }
      }),
      render: (date_committed) =>
        date_committed
          ? dayjs(date_committed).format('DD/MM/YYYY')
          : 'No especificada'
    },
    {
      title: 'Fecha Finalización',
      dataIndex: 'date_finished',
      key: 'date_finished',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      render: (date_finished) => 
        date_finished
        ? dayjs(date_finished).format('DD/MM/YYYY')
          : 'No especificada'
    },
    /* {
      title: 'Área',
      dataIndex: 'area',
      key: 'area',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      render: (_, record) => {
        const responsibleArea = record.responsible_area?.name;
        return responsibleArea || 'No especificada';
      },
      align: 'center'
    }, */
    {
      title: 'Comentarios',
      dataIndex: 'comments',
      key: 'comments',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      render: (comments) =>
        comments?.length ? (
          <Tooltip
            title={
              comments.map((c, i) => (
                <div key={i}>
                  • {c.comment.length > 15
                    ? `${c.comment.slice(0, 15)}...`
                    : c.comment}
                </div>
              ))
            }
          >
            {comments.length} comentario(s)
          </Tooltip>
        ) : '0',
      align: 'center'
    },
    {
      title: 'Tareas',
      dataIndex: 'tasks',
      key: 'tasks',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      render: (tasks) =>
        tasks?.length ? (
          <Tooltip
            title={
              tasks.map((t, i) => (
                <div key={i}>
                  • {t.description.length > 20
                    ? `${t.description.slice(0, 20)}...`
                    : t.description}
                </div>
                 /*  <strong>{t.user?.username || 'Usuario'}:</strong> */
              ))
            }
          >
            {tasks.length} tarea(s)
          </Tooltip>
        ) : '0',
      align: 'center'
    },    
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <Button
            type="link"
            disabled={!isSuperuser && (!hasAnyRole || !canGapsUpdate)}
            style={{ 
              color: (!isSuperuser && (!hasAnyRole || !canGapsUpdate)) ? '#999999' : '#006939', 
              fontSize: 18,  
              padding: '0px 4px'
            }}
            onClick={() => showModal(record, 'detail')}
          >
            <Tooltip title="Ver/Editar Issue"><EyeFilled /></Tooltip>
          </Button>
          <Tooltip title="Ver Log Issue">
            <FolderOpenFilled 
              style={{ fontSize: 20, cursor: 'pointer', color: '#006939' }}
              onClick={() => handleOpenChangeLog(record)}
            />
          </Tooltip>
          <Button 
            type="link" 
            disabled={record.isFinished || (!isSuperuser && (!hasAnyRole || !canGapsUpdate))}
            style={{ 
              color: (record.isFinished || (!isSuperuser && (!hasAnyRole || !canGapsUpdate))) 
                ? '#999999' 
                : '#F5A623', 
              fontSize: 18,  
              padding: '0px 4px'
            }}
            onClick={() => showModal(record, 'assign')}
          >
            <Tooltip title="Crear Tarea"><SnippetsFilled /></Tooltip>
          </Button>
          <Button 
            type="link"
            disabled={(() => {
              const noPermissions = !isSuperuser && (!hasAnyRole || !canGapsRead);
              
              // CASO 1: No tiene tareas (independiente del estado del issue)
              const noTasks = !record.tasks || record.tasks.length === 0;
              
              // CASO 2: Issue finalizado Y todas las tareas están finalizadas
              /* const allTasksFinished = record.tasks && record.tasks.length > 0 
                ? record.tasks.every(task => task.status?.index === 3)
                : false; */
              
              //const isFinishedWithAllTasksFinished = record.isFinished && allTasksFinished;
              
              // Deshabilitar si: NO tiene permisos O NO tiene tareas
              return noPermissions || noTasks;
            })()}
            style={{ 
              color: (
                (!isSuperuser && (!hasAnyRole || !canGapsRead)) || 
                (!record.tasks || record.tasks.length === 0)
              ) ? '#999999' : '#F5A623', 
              fontSize: 18,  
              padding: '0px 4px'
            }}
            onClick={() => showModal(record, 'view')}
          >
            <Tooltip title={
              (!record.tasks || record.tasks.length === 0)
                ? "No hay tareas para ver en este issue"
                : "Ver/Editar Tareas"
            }>
              <FileTextFilled />
            </Tooltip>
          </Button>
        </div>
      ),
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } 
      }),
      align: 'center', 
      width: '10%',
    } 
  ];
};

export default Columns;